<template>
  <div>
    <div v-if="this.$store.state.user_type === 0 || this.$store.state.user_type === 3">
      <div class="item" v-for="item in taskList" :key="item.id">
        <router-link :to="{path:'/detail',query:{id:item.id}}">
          <div class="item-top flex align-items">
            <span class="list-reward-type" v-if="item.reward_type == 0">赏金</span>
            <span class="list-reward-type" v-if="item.reward_type == 1">优惠券</span>
            <span class="list-reward-type" v-if="item.reward_type == 2">体验卡</span>
            <span class="list-reward-type" v-if="item.reward_type == 3">实物</span>
            <span class="list-reward-type" v-if="item.reward_type == 4">抽奖次数</span>
            <span class="price ff9203">￥{{item.task_price}}</span>
            <span class="title" v-text="item.task_title"></span>
            <el-tag v-text="item.task_type" size="mini"></el-tag>
          </div>
          <div class="item-center flex align-items">
            <span class="click"><i class="icon el-icon-view"></i> 点击量：{{item.task_clicks}}</span>
            <span class="number"><i class="icon el-icon-user"></i> 剩余 {{item.surplus_num}} 个接单名额</span>
            <span class="time"><i class="icon el-icon-time"></i> 该推广已结束</span>
          </div>
          <div class="item-bottom flex align-items">
            <span class="logo" v-if="item.xcmini_enterprise_user"><img :src="item.xcmini_enterprise_user.enterprise_logo" class="logo-pic"></span>
            <span class="name" v-if="item.xcmini_enterprise_user">{{item.xcmini_enterprise_user.name}}</span>
          </div>
        </router-link>
      </div>
      <div class="loading" v-if="count === 0">暂无数据</div>
      <div class="pages" v-if="count >= 10">
        <el-pagination
                @current-change="current_change"
                :current-page.sync="currentPage"
                :page-size="10"
                layout="prev, pager, next"
                :total="count"
        ></el-pagination>
      </div>
    </div>
    <div v-if="this.$store.state.user_type === 1">
      <div class="item" v-for="item in taskList" :key="item.id">
        <router-link :to="{path:'/detail',query:{id:item.id}}">
          <div class="item-top flex align-items">
            <span class="list-reward-type" v-if="item.reward_type == 0">赏金</span>
            <span class="list-reward-type" v-if="item.reward_type == 1">优惠券</span>
            <span class="list-reward-type" v-if="item.reward_type == 2">体验卡</span>
            <span class="list-reward-type" v-if="item.reward_type == 3">实物</span>
            <span class="list-reward-type" v-if="item.reward_type == 4">抽奖次数</span>
            <span class="price ff9203">￥{{item.split_price}}</span>
            <span class="title" v-text="item.task_title"></span>
            <el-tag v-text="item.task_type"></el-tag>
          </div>
          <div class="item-center flex align-items">
            <span class="click"><i class="icon el-icon-view"></i> 点击量：{{item.spilt_click}}</span>
            <span class="number"><i class="icon el-icon-user"></i> 剩余 {{item.surplus_num}} 个接单名额</span>
            <span class="time"><i class="icon el-icon-time"></i> 该推广已结束</span>
          </div>
          <div class="item-bottom flex align-items">
            <span class="logo" v-if="item.xcmini_enterprise_user"><img :src="item.xcmini_enterprise_user.enterprise_logo" class="logo-pic"></span>
            <span class="name" v-if="item.xcmini_enterprise_user">{{item.xcmini_enterprise_user.name}}</span>
          </div>
        </router-link>
      </div>
      <div class="loading" v-if="count === 0">暂无数据</div>
      <div class="pages" v-if="count >= 10">
        <el-pagination
                @current-change="current_change"
                :current-page.sync="currentPage"
                :page-size="10"
                layout="prev, pager, next"
                :total="count"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {taskList} from '@/config/api.js'
  export default {
    name: 'OnGoing',
    data () {
      return {
        count: 0,
        taskList: [],
        currentPage: 1
      }
    },
    methods: {
      getTaskList() {
        let data = {
          task_status: 2,
          user_type: this.$store.state.user_type,
          page: this.currentPage - 1,
        };
        this.$post(taskList, data)
                .then(res => {
                  const data = res.data;
                  this.count = Number(data.count);
                  this.taskList = data.list;
                })
                .catch(err => {
                  window.console.log(err);
                });
      },
      current_change (currentPage) {
        this.currentPage = currentPage;
        this.getTaskList();
      },
      toDetail (data) {
        this.$emit('event1', data)
      }
    },
    mounted() {
      this.getTaskList()
    }
  }
</script>
